<template>
  <div class="dynamic-center-detail-container">
    <div class="dynamic-center-detail-container-banner">
      <img
        src="https://image.bookgo.com.cn/bgOfficial/dynamic/dynamic-center-banner.png"
        alt=""
      />
    </div>
    <div class="dynamic-center-detail-container-activity clear">
      <div
        class="dynamic-center-detail-container-activity-left"
        v-html="content"
      ></div>
      <div class="dynamic-center-detail-container-activity-right">
        <div class="dynamic-center-detail-container-activity-right-head">
          相关文章
        </div>
        <ul class="dynamic-center-detail-container-activity-right-list">
          <li
            v-for="(item, i) in articleList"
            :key="i"
            @click="goDetail(item)"
            class="clear"
          >
            <div class="dynamic-pic">
              <img :src="item.cover" alt="" />
            </div>
            <div class="dynamic-info">
              <p>{{ item.title }}</p>
              <i>{{ item.update_time }}</i>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { list, detail } from "../../api/homepage/index";
import moment from "moment";
export default {
  data() {
    return {
      content: "",
      articleList: [],
      id: "",
    };
  },
  watch: {
    $route(newV, oldV) {
      console.log(newV);
      this.id = this.$route.query.id;
      let params = {
        id: this.id,
      };
      detail(params).then((res) => {
        console.log(res);
        if (res.code == 0) {
          this.content = res.data.article.content;
        }
      });
    },
  },
  created() {
    this.getArticleList();
    let params = {
      id: this.$route.query.id,
    };
    detail(params).then((res) => {
      // console.log(res);
      if (res.code == 0) {
        this.content = res.data.article.content;
      }
    });
  },
  methods: {
    getArticleList() {
      let params = {
        aid: 2,
        page_size: 5,
        page: 1,
        app_type: 1,
        cat_id: this.$route.query.cat_id,
      };
      list(params).then((res) => {
        if (res.code == 0) {
          this.articleList = res.data.list;
          res.data.list.forEach((item) => {
            item.update_time = moment(item.update_time * 1000).format(
              "YYYY年MM月DD日"
            );
          });
        }
      });
    },
    goDetail(item) {
      console.log(item);
      if (item.is_link) {
        window.open(item.jump_url);
      } else {
        this.$router.push({
          name: "dynamic-center-detail",
          query: { cat_id: item.cat_id, id: item.id },
          params: { content: item.content },
        });
      }
    },
  },
};
</script>

<style lang="scss">
// 最外层盒子样式
%out-box {
  width: 100%;
  position: relative;
}

// 内层盒子
%inside-box {
  width: 1200px;
  margin: 0 auto;
}
.dynamic-center-detail-container {
  &-banner {
    height: 665px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  &-activity {
    @extend %inside-box;
    margin-top: 139px;
    &-left {
      float: left;
      min-height: 600px;
      width: 859px;
      text-align: center;
      h1,
      h2,
      h3,
      h4,
      h5 {
        font-size: 30px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        line-height: 28px;
        color: #242424;
        opacity: 1;
        margin-bottom: 19px;
      }
      p {
        text-align: left;
        font-size: 18px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        line-height: 30px;
        color: #303030;
        text-indent: 2em;
      }
      img {
        width: 100%;
      }
    }
    &-right {
      float: right;
      width: 311px;
      border: 1px solid #e5e5e5;
      border-radius: 10px;
      padding: 22px 27px;
      &-head {
        font-size: 18px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        line-height: 25px;
        color: #242424;
        margin-bottom: 22px;
      }
      &-list {
        .dynamic-pic {
          float: left;
          width: 97px;
          height: 69px;
          margin-right: 13px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .dynamic-info {
          float: left;
          width: 144px;
        }
        p {
          float: right;
          font-size: 16px;
          font-family: Source Han Sans CN;
          font-weight: 300;
          line-height: 22px;
          color: #303030;
          width: 144px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2; //行数
          -webkit-box-orient: vertical;
          margin-bottom: 7px;
        }
        i {
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 300;
          line-height: 25px;
          color: #acabab;
          font-style: normal;
        }
        li {
          padding-top: 15px;
          padding-bottom: 15px;
          border-top: 1px solid #dfdfdf;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
